export {
    addHelpDeskRoute,
    addHelpResourcesRoute,
    addHelpContentRoute,
    editHelpDeskRoute,
    viewHelpDeskRoute,
} from './routes';
